import React, { useRef,useCallback } from 'react'
import Moment from 'react-moment'
import { avatarStorage_LINK } from '../../api/ApiUrl'
import { ReadMsg } from '../../config/firebaseConfig'
import Avatar from '../layout/Avatar'
import { LoginIcon, LogoutIcon, LongBreak, Salah, ShortBreak, Washroom } from '../layout/Icons'

const MessageBar = ({msg, uid, nextUid, user, prevType}) => {
const readList = Array.isArray(msg?.read) ? msg.read : [];
const currentUserId = user?.id;

//   const setActivityColor=(id)=>{
//     if(id==0){
//       return 'text-green-600 dark:text-green-500 bg-green-200 dark:bg-green-700/50'
//     }else if(id==1){
//       return 'text-indigo-800 dark:text-indigo-500 bg-indigo-200 dark:bg-indigo-900/40'
//     }else if(id==2){
//       return 'text-orange-500 dark:text-orange-500 bg-orange-200 dark:bg-orange-800/50'
//     }else if(id==3){
//       return 'text-red-600 dark:text-red-500 bg-red-200 dark:bg-red-800/60'
//     }else if(id==4){
//       return 'text-cyan-600 dark:text-cyan-500 bg-cyan-200 dark:bg-cyan-800/50'
//     }
// }

const observer=useRef();

const readingMsg=useCallback(node=>{
  var readData=Array.isArray(msg?.read) ? msg.read : [];
  if(msg?.msgType!=1 && readData.filter(r=>r==currentUserId).length>0){
    return
  }

  if(observer.current){
    observer.current.disconnect()
  }

  observer.current=new IntersectionObserver(entries=>{
    if(entries[0].isIntersecting){
      if(msg?.msgType!=1){
        const read=Array.isArray(msg?.read) ? msg.read : [];
        if(!read.filter(r=>r==currentUserId).length>0){
          const timer=setTimeout(()=>{
            var data=[...read, currentUserId];
            ReadMsg(msg.roomId, data, msg.id);
          },1000);

          return () => clearTimeout(timer);
          
        }
      }
    }
  })

  if(node){
    observer.current.observe(node)
  }

},[msg, currentUserId])

  // useEffect(()=>{
  //   if(msg.msgType!=1){
  //     const read=msg.read
  //     if(!read.filter(r=>r==user.id).length>0){
  //       var data=[...read, user.id];
  //       ReadMsg(msg.roomId, data, msg.id);
  //     }
  //   }
      
  // },[])
  return (
    <div ref={readingMsg}>
    {msg.msgType===0 &&
    <>
    {msg.uid!==nextUid && msg.uid!==uid?
     <p className={`msg-profile-name ml-8`}>{msg.uName}</p>
    :
    null}
    <div className={`${msg.uid===uid? `sender-wrapper` : `reciever-wrapper`}`}>
     {(msg.uid!==nextUid || prevType!==msg.msgType) && msg.uid!==uid ?
     <div className='msg-profile-wrapper group'>
        {msg.photoUrl!==null?
        <img src={`${avatarStorage_LINK}/${msg.photoUrl}`}  className='msg-profile-img' alt='profile'/>
        :
        <Avatar value={msg.uName} width={'7'} height={'7'} color={'bg-blue-200 dark:bg-blue-800'} />
      }
      </div>
       :
      <>
      {msg.uid!==uid&&
      <div className='bg-transparent w-7 h-7'></div> 
      }
      </>

      } 
      
      
      <div className={`${msg.uid===uid? `sender` : `reciever`} group`}>
       
        <p className={`msgText ${readList.filter(r=>r==currentUserId).length==0? `unread` : ``}`}>{msg.msg}</p>
        {msg.createdAt !=null &&
          <Moment className='hidden p-1 text-[10px] italic rounded-md group-hover:block text-slate-500 dark:text-slate-500' date={msg.createdAt.toDate()} format={'hh:mmA'}/>
        }
      </div>
      
      </div>
  </>
  }
  {msg.msgType===1 &&
    <p className='msg-system-text'>{msg.msg}</p>
  }

  {msg.msgType===3 &&
    <>
    {msg.uid!==nextUid && msg.uid!==uid?
     <p className={`msg-profile-name ml-8`}>{msg.uName}</p>
    :
    null}
    <div className={`${msg.uid===uid? `sender-wrapper` : `reciever-wrapper`}`}>
     {(msg.uid!==nextUid || prevType!==msg.msgType) && msg.uid!==uid ?
     <div className='msg-profile-wrapper group'>
        {msg.photoUrl!==null?
        <img src={`${avatarStorage_LINK}/${msg.photoUrl}`}  className='msg-profile-img' alt='profile'/>
        :
        <Avatar value={msg.uName} width={'7'} height={'7'} color={'bg-blue-200 dark:bg-blue-800'} />
      }
      </div>
       :
      <>
      {msg.uid!==uid&&
      <div className='bg-transparent w-7 h-7'></div> 
      }
      </>

      } 
      
      <div className={`${msg.uid===uid? `sender` : `reciever`} group`}>
        <a href={msg.imageUrl} target='_blank' rel='noreferrer' className={`msg-image-bubble ${readList.filter(r=>r==currentUserId).length==0? `unread` : ``}`}>
          <img src={msg.imageUrl} alt={msg.imageName || 'chat attachment'} />
          {msg.msg &&
          <span>{msg.msg}</span>
          }
        </a>
        {msg.createdAt !=null &&
          <Moment className='hidden p-1 text-[10px] italic rounded-md group-hover:block text-slate-500 dark:text-slate-500' date={msg.createdAt.toDate()} format={'hh:mmA'}/>
        }
      </div>
      
      </div>
  </>
  }

  {msg.msgType===2 &&
      <div className='msg-activity'>
        {msg.photoUrl!==null?
        <img src={`${avatarStorage_LINK}/${msg.photoUrl}`}  className='msg-profile-type-img' alt='profile'/>
        :
        <Avatar value={msg.uName} width={'6'} height={'6'} color={'bg-blue-200 dark:bg-blue-800'}/>  
        }
        {msg.completeType?
        <p className='font-bold'>&larr;</p>
        :
        <p className='font-bold'>&rarr;</p>
        }
        <LoadActivityIcon id={msg.typeId}/>
        <span className='msg-activity-label'>{activityLabel(msg.typeId, msg.completeType)}</span>
        <span className='msg-activity-timeframe'>{msg.msg}</span>

        </div>
    }

    </div>
    )
}

const activityLabel=(id, completeType)=>{
  if(id==0){
    return 'Clocked in'
  }
  if(id==1){
    return completeType ? 'Back from washroom' : 'Washroom'
  }
  if(id==2){
    return completeType ? 'Back from short break' : 'Short break'
  }
  if(id==3){
    return completeType ? 'Back from long break' : 'Long break'
  }
  if(id==4){
    return completeType ? 'Back from salah break' : 'Salah break'
  }
  if(id==-1){
    return 'Clocked out'
  }
  return 'Status'
}

const LoadActivityIcon=({id})=>{
  return(
    <>
    {id==0 &&
    <div className='msg-activity-icon bg-green-500'>
      <LoginIcon iconClass={'w-3.5 h-3.5'}/>
    </div>
    }

    {id==1 &&
    <div className='msg-activity-icon bg-indigo-800'>
      <Washroom iconClass={'w-3.5 h-3.5'}/>
    </div>
    }

    {id==2 &&
    <div className='msg-activity-icon bg-orange-500'>
      <ShortBreak iconClass={'w-3.5 h-3.5'}/>
    </div>
    }

    {id==3 &&
    <div className='msg-activity-icon bg-red-500'>
      <LongBreak iconClass={'w-3.5 h-3.5'}/>
    </div>
    }


    {id==4 &&
    <div className='msg-activity-icon bg-cyan-500'>
      <Salah iconClass={'w-3.5 h-3.5'}/>
    </div>
    }
    {id==-1 &&
    <div className='msg-activity-icon bg-red-500'>
      <LogoutIcon iconClass={'w-3.5 h-3.5'}/>
    </div>
    }

    </>

  )
}
export default MessageBar
